import Input from "../../../components/Input"
import { Grid, Stack, Chip, Box, Button, Rating} from "@mui/material"

const Skills = ({fieldValues, handleIndexedOnChange, handleAddNew, handleDelete}) => {
    const selectedTemplate = localStorage.getItem('template')
    const fields = [
        {name:'skill', label:'Skill', type: 'input'},
        {name:'rating', label:'Rating', type: 'rating'},
    ]
    const handleOnChange = (name, value, index) =>{
        handleIndexedOnChange('skills', index, name, value)
    }
    return <Grid container>
        <Grid item xs={12} px={3} display={'flex'} justifyContent={'space-between'}>
        <Stack direction="row" spacing={1}>{fieldValues['skills'].map((values, index)=>{
                return <Chip label={`Skill ${index + 1}`} onDelete={()=>handleDelete('skills', index)}/>
            })}</Stack>
            <Box><Button variant="contained" onClick={()=>handleAddNew('skills')}>Add New</Button></Box>
        </Grid>
        {fieldValues['skills'].map((values, fieldIndex)=>{
            return fields.map((field, index)=>{
                return <Grid item xs={6} p={3}>
                {field.type === 'input' && <Input name={field.name} label={field.label} value={values[field.name]} key={index} index={fieldIndex} handleOnChange={handleOnChange}/>}
                {field.type === 'rating' && selectedTemplate == 1 && <Rating name={field.name} label={field.label} value={values[field.name]} key={index} index={fieldIndex} precision={0.5} onChange={(e)=>handleOnChange(field.name, e.target.value, fieldIndex)} size="large"></Rating>}
             </Grid>
            })
        })}
    </Grid>
}

export default Skills